export default __webpack_public_path__ + "static/media/card6_right.ebd30a1f.png";